export function setTabName(state, data) {
    state.tabName       = data.name;
}